import { lt, showSuccessAlert } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { getDateTimeUtc } from '@mews-commander/utils';
import { updateTask } from '@mews-commander/legacy-entities/src/actions/tasks';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getCurrentDateTimeLocalizationInfo } from '@mews-commander/core/legacy-globalization';

export const updateTaskData =
    (task: $TSFixMe, taskId: $TSFixMe): CommanderThunkAction =>
    (dispatch, getState) => {
        const { date, time, ...other } = task;
        const timezone = getCurrentEnterpriseIanaTimeZoneIdentifier(getState());
        const localizationInfo = getCurrentDateTimeLocalizationInfo(getState());
        const deadlineUtc = getDateTimeUtc({ timezone, localizationInfo, date, time });

        return dispatch(updateTask({ taskId, deadlineUtc, ...other })).then(() =>
            showSuccessAlert({ description: lt('SaveSuccessMessage') })
        );
    };
